<template>
	<div>
		<Cadastrar :showForm="showFormCadastro" :parent="this"/>
		
		<el-tabs type="card" v-model="tagConfig" :editable="orcamentos.length>0" @tab-remove="handleTabsDelete">
			<el-tab-pane label="Config" name="tab-listar">
				<span slot="label">
					<i class="fa fa-list-alt"></i> Orçamentos Cadastrados
				</span>

				<ed-table
					registerName="Gerar Novo Orçamento"
					:onRegister="(this.validarPermissao(577) ? onRegister : null)" 
					:onEdit="onEdit"
					:onDelete="onDelete"
					:onSearch="getLtcatOrcamento"
					:tableHead="tableHead"
					:tableData="tableData"
					:loadingTable="loadingTable"
					:pagination="pagination"
					:response="response"
				/>
			</el-tab-pane>

			<el-tab-pane label="Config" :name="'tab-editar-'+i" v-for="(orcamento,i) in orcamentos" :key="i">
				<span slot="label">
					<i class="fa fa-pencil-square-o"></i> Editar Orçamento {{orcamento.codigo}}
				</span>
				<Editar :showForm="showFormEdit" :parent="this" :orcamento="orcamento"/>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	
	import EdTable from 'common/table'
	import Rest from 'common/rest'
	import Editar from './editar'
	import Cadastrar from './cadastrar'

  	export default {
  		name:"exame",
  		components: {EdTable,Cadastrar,Editar},
		mixins:[Rest],
		props:{
			ltcat:{
				type: Object,
				default: null
			}
		},
		watch: {
			'$store.state.ltcat.data.id'(){
				this.getLtcatOrcamento();
			},
		},
  		data () {
		   	return {
				pagination:{},
				response:{},
		   		tableHead:[
					{
		                key: 'id',
						sortable: true,
						label: 'CÓDIGO',
					},
					{
		                key: 'descricao',
						sortable: true,
						label: 'Descrição',
					},
					{
		                key: 'tipo_status',
						sortable: true,
						label: 'Status',
					},
					{
		                key: 'updated_at',
						sortable: true,
						show_user:true,
						label: 'Atualização',
		            },
		   		],
		   		tableData:[],
		   		loadingTable:false,
				showFormEdit:false,
				showFormCadastro:false,
				tagConfig:'tab-listar',
				orcamentos:[]

			}
		},

		created(){
			
		},

		mounted: function() {
			this.getLtcatOrcamento();

			this.$events.on('ckeditor-pdf', eventData => {
			  this.formData.pdf = eventData;
      });
      
      this.$events.on('orcamentoProposta', eventData => {
        this.getLtcatOrcamento();
      });
		},	

		methods: {

			onRegister: function(){
				this.showFormCadastro = !this.showFormCadastro;
				this.orcamentos = [];
			},

			onEdit: function(data){

				var index = (this.orcamentos.length-1);

				if(!this.arrFindByField(this.orcamentos,'id',data.id)){
					this.orcamentos.push(data);
				}

				for (let i = 0; i < this.orcamentos.length; i++) {
					const element = this.orcamentos[i];
					if(data.id == element.id){
						index = i;
					}
					
				}
				this.tagConfig = 'tab-editar-'+index;
			},

			onDelete: function(data){

				var self = this;

                this.$confirm('O sistema vai excluir '+data.length+' registro(s). Deseja prosseguir?', 'Atenção', {
                    type: 'warning'

                }).then(() => {

                    self.loadingTable = true;

                    this.post('/ltcat/orcamento/'+this.$store.state.ltcat.data.id+'/deletar',{ids:data}).then((result)=>{
                        result = result[0];

                        self.loadingTable = false;

                        if(result.status == 200){
							self.getLtcatOrcamento();
							self.handleTabsDelete();
                            self.edMsg('Registo excluido com sucesso');
                        }
                    });

                });
			},

			handleTabsDelete(targetName, action) {
				this.tagConfig = 'tab-listar';

				var index = this.onlyNumber(targetName);

				for (let i = 0; i < this.orcamentos.length; i++) {
					const element = this.orcamentos[i];

					if(i == index){
						this.orcamentos.splice(i,1);
					}
				}
			},

			getLtcatOrcamento: function(_search,_page,_pagination){
				
				if(!this.$store.state.ltcat.data)return;

				this.loadingTable = true;
				this.response = {};

				this.get('ltcat/orcamento/'+this.$store.state.ltcat.data.id,{search:_search,page:_page,pagination:_pagination,filter:{show_emp_email:1}}).then((result)=>{

		            result = result[0];
					this.response = result;

		            if(result.status == 200){

		             	var
		             		data = result.data.data,
		             		tableData = [],
		             		pagination = result.data

		             	for (var i = 0; i < data.length; i++) {

							data[i].collapse = null;

		             		var item = {
		             			'id': data[i].codigo,
								'descricao': (data[i].descricao ? data[i].descricao : '---'),
								'tipo_status': (data[i].tipo_status ? data[i].tipo_status.descricao : '---'),
								'updated_at': this.toDate(data[i].updated_at),
		             			_data:data[i],
		             			options:{
									disable_delete:(!this.validarPermissao(577) || data[i].tipo_status.bloqueado == 1),
									disable_edit:!this.validarPermissao(577),
								},
		             			buttons:[]
		             		};

		             		tableData.push(item);
		             	}

		             	this.pagination = pagination;
		             	this.tableData = tableData;
					}
					
					this.loadingTable = false;
	            });
			},

		}
  	}
</script>


// WEBPACK FOOTER //
// index.vue?5ac134b9